import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useBreakpointValue} from '@chakra-ui/react'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import {isServer} from '../utils/utils'
import {breakpoints} from '../theme/_utils'

export const getDamBaseUrl = () => {
    const {customParams} = getConfig()
    const baseUrl = `${customParams?.dam?.protocol}://${customParams?.dam?.domain}`

    return baseUrl
}

export const getDamProductUrl = () => {
    const {customParams} = getConfig()
    const baseUrl = `${customParams?.dam?.protocol}://${customParams?.dam?.products}`

    return baseUrl
}

export const windowGetBreakpoint = (width) => {
    if (width < parseInt(breakpoints.md)) return 'mobile'
    else if (width < parseInt(breakpoints.lg)) return 'tablet_768'
    else if (width < parseInt(breakpoints.xl)) return 'tablet_1024'
    else return 'desktop'
}

/**
 *
 * @param {object} contentStackObj - content stack field that contains the image obj
 * @returns {string} - full path to the image
 *
 */
const useDamImage = (contentStackObj) => {
    const {res} = useServerContext()

    let breakpoint = useBreakpointValue(
        {
            base: 'mobile',
            md: 'tablet_768',
            lg: 'tablet_1024',
            xl: 'desktop',
        },
        {
            fallback: null,
        },
    )

    if (!breakpoint) {
        if (res?.locals?.ua?.isMobile) breakpoint = 'mobile'
        else if (res?.locals?.ua?.isTablet) breakpoint = 'tablet_1024'
        else if (res?.locals?.ua?.isDesktop) breakpoint = 'desktop'
        else if (isServer) breakpoint = 'mobile'
        else {
            breakpoint = windowGetBreakpoint(window?.innerWidth)
        }
    }

    const DEFAULT_RENDITION = 16 / 9
    const EMPTY_DAM_IMAGE = {
        url: '',
        ratio: DEFAULT_RENDITION,
    }

    if (!contentStackObj || !/x/.test(contentStackObj?.[breakpoint]?.rendition))
        return EMPTY_DAM_IMAGE

    let damImage = contentStackObj?.[breakpoint]?.dam_image?.[0]

    if (!damImage && breakpoint === 'tablet_768') {
        damImage = contentStackObj?.['mobile']?.dam_image?.[0]
    }

    if (!damImage && breakpoint === 'tablet_1024') {
        damImage = contentStackObj?.['desktop']?.dam_image?.[0]
    }

    const baseUrl = getDamBaseUrl()
    const ratioFactors = contentStackObj[breakpoint].rendition.split('x')

    return {
        url: damImage?.id
            ? `${baseUrl}/${contentStackObj[breakpoint].rendition}/assets/${damImage?.id}`
            : '',
        ratio: ratioFactors[1] ? ratioFactors[0] / ratioFactors[1] : DEFAULT_RENDITION,
    }
}

export default useDamImage
